import React, { useState } from "react";
import logo from "../../Assets/Logo/small.png";
import lock from "../../Assets/Icon/lock.webp";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { SubmitPassword } from "../../Repository/Api";
import { errorMsg, successMsg } from "../Toastify";

const ResetPassword = () => {
  const state = useSelector((state) => state);
  const navigate = useNavigate();

  const [login, SetLogin] = useState([]);
  const [validation, setValidation] = useState({});
  const [password, setPassword] = useState();

  const setData = (e, key) => {
    let TempData = login;
    TempData[key] = e;
    SetLogin(TempData);
    if (validation[key]) setValidation({ ...validation, [key]: false });
  };

  const viewPassword = () => {
    setPassword(!password);
  };

  const CheckValidation = () => {
    let Status = true,
      validdateData = {};
    if (!login.password) {
      validdateData.password = "Password is Required";
      Status = false;
    } else if (login.password.localeCompare(login.repassword) !== 0) {
      validdateData.repassword = "Password and Re-Enter Password doesn't match";
      Status = false;
    }
    setValidation({ ...validation, ...validdateData });
    return Status;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const Payload = {
      user_name: state.auth.registerData,
      password: login.password,
    };
    if (CheckValidation()) {
      const response = await SubmitPassword(Payload);
      if (response && response.statusCode === 200) {
        successMsg(response.message);
        getTimeout();
      } else {
        errorMsg(response.message);
      }
    }
  };

  const getTimeout = () => {
    setTimeout(() => {
      setTimeout(navigate("/"));
    }, 1000);
  };

  return (
    <>
      <section className="signin">
        <div className="container">
          <div className="row">
            <div className="col-lg-5 ms-auto mx-auto">
              <div className="signinlogospace">
                <div className="centertext">
                  <img className="signinlogo" src={logo} alt="NITTTR" />
                </div>
                <div className="my-5">
                  <form onSubmit={(e) => handleSubmit(e)}>
                    <div className="inputspace">
                      <img className="icon" src={lock} alt="User" />
                      <input
                        type={password ? "text" : "password"}
                        className="input-field"
                        placeholder="NEW PASSWORD"
                        defaultValue={login.password}
                        onChange={(e) => {
                          setData(e.target.value, "password");
                        }}
                      />
                      <div className="psw-icon">
                        {password ? (
                          <span
                            className="material-symbols-rounded cursor align-middle"
                            onClick={() => viewPassword()}
                          >
                            visibility
                          </span>
                        ) : (
                          <span
                            className="material-symbols-rounded cursor align-middle"
                            onClick={() => viewPassword()}
                          >
                            visibility_off
                          </span>
                        )}
                      </div>
                      {validation.password && (
                        <p className="validationmsg">{validation.password}</p>
                      )}
                    </div>
                    <div className="inputspace">
                      <img className="icon" src={lock} alt="User" />
                      <input
                        type={password ? "text" : "password"}
                        className="input-field"
                        placeholder="CONFIRM PASSWORD"
                        onChange={(e) => {
                          setData(e.target.value, "repassword");
                        }}
                      />
                      <div className="psw-icon">
                        {password ? (
                          <span
                            className="material-symbols-rounded cursor align-middle"
                            onClick={() => viewPassword()}
                          >
                            visibility
                          </span>
                        ) : (
                          <span
                            className="material-symbols-rounded cursor align-middle"
                            onClick={() => viewPassword()}
                          >
                            visibility_off
                          </span>
                        )}
                      </div>
                      {validation.repassword && (
                        <p className="validationmsg">{validation.repassword}</p>
                      )}
                    </div>
                    <div className="inputspace">
                      <button className="loginbtn">Update Password</button>
                    </div>
                    <p
                      className="text-end cursor"
                      onClick={() => {
                        navigate("/");
                      }}
                    >
                      <small>Back to Login</small>
                    </p>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ResetPassword;
